define('shared/initializer/form/adapters/mixins/fields/DynamicSubscribe',[
    '$',
    'shared/initializer/form/constants',
    'shared/lib/RSVP',
    'shared/util/fields/common',
    'shared/util/checkout/emailSubscriptions'
],
function (
    $,
    constants,
    RSVP,
    fieldUtil,
    emailSubscriptionsUtil
) {
    'use strict';

    function Ctor() { }

    var p = Ctor.prototype;

    p.doBeforeSubmit = function(){
        var me = this;

        var dynamicSubscribeFields = me.$form.find('input[name=' + constants.FIELD.DynamicSubscribe + ']');
        if(dynamicSubscribeFields.length === 0){
            return RSVP.resolve();
        }

        var allSubscriptions = [];
        for(var i = 0; i < dynamicSubscribeFields.length; i++){
            /*jshint loopfunc: true */

            var field = dynamicSubscribeFields[i];
            var subscriptionStr = field.checked ? $(field).attr('checkedSubscriptions') : $(field).attr('unCheckedSubscriptions');
            if(!subscriptionStr){
                continue;
            }

            subscriptionStr.split(',').forEach(function(subscription){

                if(allSubscriptions.indexOf(subscription) < 0){
                    allSubscriptions.push(subscription);
                }
            });
        }

        // After learning it the hard way, we found out EmailEnglish=true doesn't mean we are subscribing to emailenglish
        // the emailenglish here is somehow just for server side to pickup "emailist" field value correctly
        // so this should always be true:
        // https://bitbucket.englishtown.cn/projects/COSAM/repos/salespages/browse/SalesPages.Web/HttpHandler/LandingPageHandler.cs#241
        fieldUtil.setFieldValue('true', constants.FIELD.EmailEnglish, me.$form);
        fieldUtil.setFieldValue('true', constants.FIELD.EnglishEmail, me.$form);

        fieldUtil.setFieldValue(allSubscriptions.join(','), constants.FIELD.EmailList, me.$form);

        allSubscriptions.forEach(function(subID){
            fieldUtil.setFieldValue('true', emailSubscriptionsUtil.subscriptions[subID], me.$form);
        });

        return RSVP.resolve();
    };

    return Ctor;
});

